import { faSeedling, faHandshakeSimple, faStar, faFlag, faBolt, faShieldHalved } from '@fortawesome/free-solid-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export const badgeIcons: Record<string, IconDefinition> = {
  Initiator: faSeedling,
  Ambassador: faFlag,
  Pionnier: faStar,
  Fiable: faShieldHalved,
  "Confiance partagée": faHandshakeSimple,
  "Actif/Active": faBolt
};